var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorderShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 396,
    viewBox: "0 0 396 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 75.5378,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 95.5042,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 118.798,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 145.42,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 170.378,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 197,
    stroke: "#55B4F1",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderShape);
export default __webpack_public_path__ + "static/media/border-shape.d3b7cf85cfc8f425435b0bf92cdf732f.svg";
export { ForwardRef as ReactComponent };